import { render, staticRenderFns } from "./popup.component.vue?vue&type=template&id=16cc852e&scoped=true&"
import script from "./popup.component.js?vue&type=script&lang=js&"
export * from "./popup.component.js?vue&type=script&lang=js&"
import style0 from "./popup.component.scss?vue&type=style&index=0&id=16cc852e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc852e",
  null
  
)

export default component.exports